// extracted by mini-css-extract-plugin
export default {"wrapper":"_f1982050"};